import Footer from '@components/common/footer'
import Navbar from '@components/common/navbar'
import Activities from '@components/course-landing-page/activities'
import CourseDescription from '@components/course-landing-page/course-description'
import CourseModule from '@components/course-landing-page/course-module'
import FirstFold from '@components/course-landing-page/first-fold'
import FooterBanner from '@components/course-landing-page/footer-banner'
import SkillsYouWillGain from '@components/course-landing-page/skills-you-will-gain'
import StemAccredited from '@components/course-landing-page/stem-accredited'
import TestimonialsFold from '@components/course-landing-page/testimonial'
import useStoreUTMParams from '@hooks/useStoreUTMParam'
import { COURSE_NAMES } from '@lib/data/course-landing-page'
import { hpeCodewarsCodeBattleCourse } from '@lib/seo'
import { CourseJsonLd, NextSeo } from 'next-seo'
import dynamic from 'next/dynamic'
import { useState } from 'react'

const CourseCard = dynamic(() =>
  import('@components/course-landing-page/course-card')
)

const { HPE_CODEWARS_CODE_BATTLE } = COURSE_NAMES

const HPECodewarsCodeBattle = () => {
  const [shouldUpdateCourseCard, setShouldUpdateCourseCard] = useState(false)

  const handleHideCourseCard = (value: boolean) => {
    setShouldUpdateCourseCard(value)
  }

  useStoreUTMParams()

  return (
    <>
      <NextSeo {...hpeCodewarsCodeBattleCourse} />
      <CourseJsonLd
        courseName="Hpe CodeWars Code Battle Course"
        description="Learn to ace the Code Battle competition with the custom course taught by our expert instructors."
        provider={{
          '@type': 'Organization',
          name: 'Codingal',
        }}
        offers={{
          '@type': 'Offer',
          category: 'Paid',
        }}
        hasCourseInstance={{
          '@type': 'CourseInstance',
          courseMode: 'Online',
          courseWorkload: 'PT12H',
        }}
      />
      <Navbar tryFreeClassLink="/register/?course=hpe-codewars-micro-course" />
      <FirstFold
        getShouldHideCourseCard={handleHideCourseCard}
        courseName={HPE_CODEWARS_CODE_BATTLE}
        courseContentText="100+ questions"
        ishideStarRating
        ishideDownloadCurriculum
        bgImageUrl="/images/courses/bg2.jpg"
        isHpePage
        urlQuery="?course=hpe-codewars-micro-course"
        customPoints="100 + questions"
      />
      <div className="container flex justify-between pt-10 mx-auto px-5 lg:px-10 text-grey">
        <div className="pb-10 md:w-4/5 md:pr-4 max-w-3xl">
          <CourseDescription
            courseName={HPE_CODEWARS_CODE_BATTLE}
            hideReadMore
          />
          <CourseModule
            courseName={HPE_CODEWARS_CODE_BATTLE}
            heading="What will you learn in this course"
            subHeading="12 hours of live session, 100+ questions, quizzes & activities"
          />
          <SkillsYouWillGain
            courseName={HPE_CODEWARS_CODE_BATTLE}
            urlQuery="?course=hpe-codewars-micro-course"
          />
          <Activities courseName={HPE_CODEWARS_CODE_BATTLE} />
          <StemAccredited
            heading="STEM.org Accredited Educational Experience"
            urlQuery="?course=hpe-codewars-micro-course"
          />
          <TestimonialsFold
            courseName={HPE_CODEWARS_CODE_BATTLE}
            heading="Hear what the winners have to say"
            urlQuery="?course=hpe-codewars-micro-course"
          />
        </div>
        <div className="hidden ml-4 md:block w-80">
          <div className="pb-5 sticky top-0 pt-5 z-40 w-80">
            {shouldUpdateCourseCard && (
              <CourseCard
                shouldHideCardImage={true}
                courseName={HPE_CODEWARS_CODE_BATTLE}
                ishideStarRating
                ishideDownloadCurriculum
                isHpePage
                urlQuery="?course=hpe-codewars-micro-course"
                customPoints="100 + questions"
              />
            )}
          </div>
        </div>
      </div>
      <FooterBanner
        title="Ace the HPE CodeWars Code battle competition with custom course"
        imagePath="/images/courses/ads-banner/ads-banner-1"
        mobileImagerPath="/images/courses/ads-banner/ads-banner-1-mobile"
        url="/register/?course=hpe-codewars-micro-course"
      />
      <Footer />
    </>
  )
}
// TODO: Remove once getInitialProps is removed from _app.tsx
export const getStaticProps = async () => {
  return {
    props: {},
  }
}

export default HPECodewarsCodeBattle
